var swiperDestaque = new Swiper(".destaqueSwiper", {
    slidesPerView: 4,
    spaceBetween: 16,
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 16,
        }
      },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: true,
});
